export default __webpack_public_path__ + "474f240980b258a630744c2548897e40.png";